import { CanadaPostQueryParams } from "./CanadaPostQueryParams";

class CanadaPostClient {
    private static readonly url = "https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/Find/v2.10/json3ex.ws";

    public static GetWithSearchTerm(searchTerm: string, callback: (response: any) => void): void {
        CanadaPostClient.RawGet(CanadaPostQueryParams.defaultWithSearchTerm(searchTerm), response => callback(response));
    }

    public static GetWithLastId(id: string, callback: (response: any) => void): void {
        CanadaPostClient.RawGet(CanadaPostQueryParams.defaultWithLastId(id), response => callback(response));
    }

    private static RawGet(data: any, onSuccess: (data: any, textStatus: string, jqXHR: JQueryXHR) => any): void {
        // assuming app runs not as an application of another website
        jQuery.ajax(
            CanadaPostClient.url,
            {
                data: data,
                method: "GET",
                crossDomain: true,
                dataType: "json",
                success: onSuccess,
                error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
                    console.warn(`Unable to fetch ${CanadaPostClient.url}. Error: ${errorThrown}`);
                }
            }
        );
    }
}

export { CanadaPostClient };
